export type PropertyPhoto = {
  img: string;
};

export type PropertyData = {
  order?: number;
  id: string;
  titulo: string;
  comuna: string;
  tipo: string;
  m2: number | string;
  precio: number | string;
  terraza: number | string;
  m2_totales: number | string;
  dormitorios: number | string;
  banhos: number | string;
  estacionamientos: number | string;
  bodega: number | string;
  piso: number | string;
  orientacion: string;
  year: number | string;
  GComunes: number | string;
  Contribuciones: number | string;
  otros: string;
  calefaccion: string;
  aguacaliente: string;
  descripcion: string;
  fotos: PropertyPhoto[];
};

const PROPERTIES_URL =
  "https://mapropiedades.blob.core.windows.net/fotos/propiedades.json";

export async function fetchProperties(): Promise<PropertyData[]> {
  const response = await fetch(PROPERTIES_URL);

  if (!response.ok) {
    throw new Error(`No se pudieron cargar las propiedades (${response.status})`);
  }

  return response.json();
}

export function formatNumber(value: number | string): string {
  const numericValue = Number(value);

  if (Number.isNaN(numericValue)) {
    return String(value);
  }

  return numericValue.toLocaleString("es-CL");
}

export function getPhotoUrl(photo: PropertyPhoto): string {
  if (photo.img.startsWith("http")) {
    return photo.img;
  }

  return `${process.env.PUBLIC_URL}/fotos${photo.img}`;
}
